export const Elevation = {
  Alert: 90,
  Navbar: 100,
  ModalWrapper: 998,
  ModalContent: 999
};
